import { render, staticRenderFns } from "./NewsListItemV2.vue?vue&type=template&id=e8387364&scoped=true"
import script from "./NewsListItemV2.vue?vue&type=script&lang=js"
export * from "./NewsListItemV2.vue?vue&type=script&lang=js"
import style0 from "./NewsListItemV2.vue?vue&type=style&index=0&id=e8387364&prod&lang=scss&scoped=true"
import style1 from "./NewsListItemV2.vue?vue&type=style&index=1&id=e8387364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8387364",
  null
  
)

export default component.exports